import gql from "graphql-tag";

export const editProduct = gql`
  mutation editProduct(
    $product: EditProductInput!
    $options: EditOptionsInput
    $variants: EditVariantsInput
    $images: EditImagesInput
  ) {
    editProduct(
      product: $product
      options: $options
      variants: $variants
      images: $images
    ) {
      id
      name
      description
      price
      sku
      stock
    }
  }
`;
